import { BrowserRouter, Route, Routes } from "react-router-dom";
import Registartion from "./components/Registartion";
import SignIn from "./components/SignIn";
import DashboardLayout from "./Layouts/DashboardLayout";
import CreateEvent from "./components/CreateEvent";
import Configuration from "./components/Configuration";
import AddGuest from "./components/AddGuest";
import YourGuests from "./components/YourGuests";
import Paymentpage from "./components/Paymentpage";
import Rate from "./components/Rate";
import YourTestimonials from "./components/YourTestimonials";
import ContactUs from "./components/ContactUs";
import QrCode from "./components/QrCode";
import VideoTutorials from "./components/VideoTutorials";
import ViewEvents from "./components/ViewEvents";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import SubmitReview from "./submit-review/SubmitReview";
import Profile from "./components/Profile";
import "react-toastify/dist/ReactToastify.css";
import { getProfile } from "./Redux/Action/AuthAction";
import SuccessPayment from "./components/SuccessPayment";
import FailurePayment from "./components/FailurePayment";
import PaymentLayout from "./Layouts/PaymentLayout";
import VerifyEmail from "./components/VerifyEmail";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import MediaGallery from "./components/MediaGallery";
import Gallery from "./components/Gallery";

function App() {
  const dispatch = useDispatch();
  const Auth = useSelector((state) => state.Auth);

  const [isLogin, setIsLogin] = useState(!!localStorage.getItem("authToken"));

  if (
    localStorage.getItem("authToken") &&
    localStorage.getItem("authToken") !== "" &&
    localStorage.getItem("authToken") !== "null"
  ) {
    Auth.isLogin = true;
    Auth.token = localStorage.getItem("authToken");
    window.scrollTo({ top: 0 });
  }

  useEffect(() => {
    if (Auth.isLogin && Auth.token !== "") {
      dispatch(getProfile());
      localStorage.setItem("authToken", Auth.token);
      setIsLogin(true);
    } else {
      if (
        localStorage.getItem("authToken") &&
        localStorage.getItem("authToken") !== "" &&
        localStorage.getItem("authToken") !== "null"
      ) {
        setIsLogin(true);
      } else {
        setIsLogin(false);
      }
    }

    const handleStorageChange = () => {
      setIsLogin(
        localStorage.getItem("authToken") !== "" &&
        localStorage.getItem("authToken") !== null
      );
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [Auth.isLogin, Auth.token, dispatch]);

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        draggable
        pauseOnHover
        className="toast-container"
      />
      <BrowserRouter>
        {!isLogin ? (
          <Routes>
            <Route path="/reg" element={<Registartion />} />
            <Route path="/" element={<SignIn />} />
            <Route path="/*" element={<SignIn />} />
            <Route path="/verify-email/:token" element={<VerifyEmail />} />
            <Route path="/submit-review/:token?" element={<SubmitReview />} />
            <Route path="/media-gallery/:token?" element={<Gallery />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
          </Routes>
        ) : (
          <>
            <Routes>
              <Route path="/submit-review/:token?" element={<SubmitReview />} />
              <Route path="/media-gallery/:token?" element={<Gallery />} />
            </Routes>
            <Routes>
              <Route path="/" element={<DashboardLayout />}>
                <Route index element={<ViewEvents />} />
                <Route path="/MediaGallery" element={<MediaGallery />} />
                <Route path="/CreateEvent" element={<CreateEvent />} />
                <Route path="/Configuration" element={<Configuration />} />
                <Route path="/AddGuest" element={<AddGuest />} />
                <Route path="/GuestList" element={<YourGuests />} />
                <Route path="/Payment" element={<Paymentpage />} />
                <Route path="/Rate" element={<Rate />} />
                <Route path="/Testimonials" element={<YourTestimonials />} />
                <Route path="/QRCode" element={<QrCode />} />
                <Route path="/VideoTutorials" element={<VideoTutorials />} />
                <Route path="/ContactUs" element={<ContactUs />} />
                <Route path="/profile" element={<Profile />} />
              </Route>
            </Routes>
            <Routes>
              <Route path="/" element={<PaymentLayout />}>
                <Route path="/payment/success" element={<SuccessPayment />} />
                <Route path="/payment/failed" element={<FailurePayment />} />
              </Route>
            </Routes>
          </>
        )}
      </BrowserRouter>
    </>
  );
}
export default App;
